import script from "./AdminMembers.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMembers.vue?vue&type=script&setup=true&lang=js"

import "./AdminMembers.vue?vue&type=style&index=0&id=1a69435d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a69435d"]])

export default __exports__